import { useMemo } from 'react';
import { TopBarMixedGroup } from '@components/features/filters/partials/TopBarMixedGroup';
import { CustomPillTopBarProps } from '@type/filters';
import { SearchInForm } from '../forms/SearchInForm';
import { filterStyles } from '../helpers/filterStyles';


/**
 * @description The top bar Search In filter component.
 * ***submitFunc** - the function to trigger the form submit.
 * ***recordFunc** - the 'record' function from useBjForm.
 * ***clearGroup** - the function to clear the group. Defaults to undefined.
 * ***idPrefix** - the prefix for the form elements ids. When using multiple forms on the same page,
 * this is needed to avoid duplicate ids.
 * **updateFormElements** - the function to force the update the form elements on open. Defaults to undefined.
 */
export const TopBarSearchIn = (props: CustomPillTopBarProps) => {
  // Destructure props
  const {
    submitFunc,
    recordFunc,
    clearGroup,
    idPrefix,
    updateFormElements,
    updateFormValues,
    queryParams,
  } = props;


  // Filters labels
  const filtersLabels = useMemo(() => ({
    nameSearch: {
      1: 'global.filter.candidate-name',
      2: 'global.filter.experience-label',
    },
    presentExperience: 'resume.filter.label.experience-last',
    queryFields: {
      1: 'filters.search-in.query.title.label',
      2: 'filters.search-in.query.description.label',
      3: 'filters.search-in.query.employer-name.label',
      4: 'filters.search-in.query.skills.label',
    },
  }), []);


  // Render the panel
  // **********************************************
  const renderPanel = () => (
    <SearchInForm
      recordFunc={recordFunc}
      submitFunc={submitFunc}
      verticalSpacing="gap-0 divide-y divide-dashed"
      customLabelStyles={`${filterStyles.listboxOption} !m-0 !py-2.5`}
      customLabelStylesNestedWrapper="!m-0 !p-0 divide-y divide-dashed"
      customLabelStylesNested={`${filterStyles.listboxOption} !m-0 !pl-8 !py-2.5`}
      titleStyles="py-3 text-ink-light px-3.5 text-sm"
      idPrefix={idPrefix}
    />
  );


  // Render component
  // **********************************************
  return (
    <TopBarMixedGroup
      submitFunc={submitFunc}
      clearGroup={clearGroup}
      updateFormElements={updateFormElements}
      updateFormValues={updateFormValues}
      buttonLabel="global.filter.search-in"
      filtersLabels={filtersLabels}
      renderPanel={renderPanel}
      queryParams={queryParams}
    />
  );
};
